import EventEmitter from 'eventemitter3';
export const eventBus = new EventEmitter();

export const AI_CONTEXT_CHANGED = 'AI_CONTEXT_CHANGED';
export const AI_REPEATING_MESSAGE = 'AI_REPEATING_MESSAGE';
export const AI_REPEATING_MESSAGE_START = 'AI_REPEATING_MESSAGE_START';
export const AI_REPEATING_MESSAGE_STOP = 'AI_REPEATING_MESSAGE_STOP';